import React from 'react'
import { useEffect, useRef, useState } from 'react'
import { SLowcodeList, SAside } from 'shj-components'
import { message, notification, InputNumber } from 'antd'
import {
  queryConstructionItem,
  queryconstructionItemCategory,
  chooseSubmit,
  allSubmit,
} from '@/services/pms.ts'
import { useUpdateEffect } from 'ahooks'
import { selectcompanyByFront } from '@/services/homeService'
import ContentModal from './components/contentModal'
import { config } from './config/index.tsx'
import styles from './index.module.less'

export default function ChooseConstruction() {
  const [openPrintModal, setOpenPrintModal] = useState(false)
  const [chooseDiabled, setChooseDisabled] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [treeData, setTreeData] = useState<any>([])
  const [prodCateId, setProdCateId] = useState('')
  const [dataList, setDataList] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const listRef = useRef()

  useUpdateEffect(() => {
    listRef.current?.reload()
  }, [prodCateId])

  const fetchList = async values => {
    try {
      const res: any = await queryConstructionItem({
        ...values,
        ...values.query,
        pageId: values?.current,
        itemCode: values?.query?.itemCode,
        nameKey: values?.query?.nameKey,
        extendCatId: prodCateId,
        orgId: values?.query?.orgId,
        searchFlag: true,
        enableFlag: true,
        orderBys: [
          {
            columnName: 'id',
            asc: false,
          },
        ],
      })
      if (!res?.list) {
        message.error('查询列表失败')
        return
      }
      setTotalCount(res?.count)
      setDataList(res?.list)
      return {
        records: res?.list,
        total: res?.count,
      }
    } catch (err) {
      message.error('查询列表失败')
    }
  }

  // 右侧表格事件：
  const allSelect = () => {
    if (chooseDiabled) {
      setChooseDisabled(false)
      listRef?.current?.clearSelectedRowKeys()
    } else {
      setChooseDisabled(true)
      const ids: any = dataList?.map((item: any) => item.id)
      setSelectedRowKeys(ids)
    }
  }

  const openCategoryModal = () => {
    if (!selectedRowKeys?.length) {
      message.info('请先选择施工项')
      return
    }
    setOpenPrintModal(true)
  }

  //   左侧树节点事件
  const onChangeType = (node: any) => {
    console.log(node)
    setProdCateId(node?.[0])
  }

  const onSubmit = async (
    prodCatId,
    grossRate,
    specialCode = '',
    prodType,
    applyMaterialSelections
  ) => {
    try {
      if (!chooseDiabled) {
        // 选择提交
        const res: any = await chooseSubmit({
          prodCatId,
          grossRate,
          specialCode,
          prodType,
          applyMaterialSelections,
          constructionItemIdList: [...selectedRowKeys],
        })
        if (!res.errorCode) {
          message.success('提交成功')
          listRef?.current?.reload()
        } else {
          message.error('提交失败')
        }
      } else {
        // 全部提交
        const searchData = listRef?.current?.getSearch()?.getFieldsValue()
        const res: any = await allSubmit({
          prodCatId,
          specialCode,
          prodType,
          extendCatId: prodCateId,
          applyMaterialSelections,
          ...searchData,
        })
        if (!res.errorCode) {
          message.success('提交成功')
          setChooseDisabled(false)
          listRef?.current?.reload()
        } else {
          message.error('提交失败')
        }
      }
      setOpenPrintModal(false)
    } catch (err) {
      console.log(err)
    }
  }

  //   右侧下拉选项加载
  const getOptions = async () => {
    const categoryTree: any = await queryconstructionItemCategory({ allFlag: true, enabled: true })
    const companyList: any = await selectcompanyByFront({})
    setTreeData([{ label: '不限', id: '' }, ...categoryTree])
    return Promise.resolve({ categoryTree, companyList })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: { allSelect, openCategoryModal },
    getCheckboxProps: record => ({
      disabled: chooseDiabled,
    }),
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(keys)
    },
    customRender: {
      numberRender({ name, form }) {
        return (
          <InputNumber
            style={{ width: '100%' }}
            placeholder={'有效产品数'}
            onInput={v => {
              form.setFieldsValue({ [name]: v })
            }}
          />
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      <div className={styles.leftMenu}>
        {/* 左侧树形选择 */}
        <SAside
          treeData={treeData}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          // active={state.categoryCode}
          fieldNames={{ title: 'label', key: 'id' }}
          header={false}
          dropItems={false}
        />
      </div>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        <SLowcodeList
          ref={listRef}
          searchMode="group"
          config={config}
          rowSelectedTotal={chooseDiabled ? totalCount : ''}
          {...extensions}
        />
      </div>
      {openPrintModal && (
        <ContentModal
          submit={async (id, grossRate, specialCode, prodType, applyMaterialSelections) =>
            await onSubmit(id, grossRate, specialCode, prodType, applyMaterialSelections)
          }
          onClose={() => setOpenPrintModal(false)}
          open={openPrintModal}
          totalCount={chooseDiabled ? totalCount : 0} 
        />
      )}
    </div>
  )
}
